import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class LLMTestResultsService extends BaseService {
  constructor() {
    super(constants.GET_LLM_TEST_RESULTS_DATA, 'LLMTestResultsServiceStatus');
  }

  handleEvent(eventName, event) {
    const headers = {
      'x-berlin-tenant-id': event.payload.tenantId
    };
    return this.getClient('evergreen').get(`/effectiveness/results/${event.payload.testId}`, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success' && data.data.length > 0) {
      const notification = {
        open: true,
        type: 'success',
        message: 'Data Fetched successfully'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('effectivenessData').setResponse(data);
    }
    if (data.status === 'success' && data.data.length === 0) {
      const notification = {
        open: true,
        type: 'error',
        message: 'No Data Found'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('effectivenessData').setResponse(data);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
